export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
    maximumFractionDigits: 0,
  }).format(amount);
};

// GTM v1 funnel: 6 steps, ending on the review + result screen. Phase 2 (phone verification,
// bank statements / open banking, ID + selfie) adds steps back — see onboarding-steps/phase2/.
export const TOTAL_STEPS = 6;

export const progressMap = {
  1: 12,
  2: 28,
  3: 45,
  4: 62,
  5: 80,
  6: 100,
};

export const encouragementMessages = {
  1: null,
  2: 'Nice! Quick progress',
  3: "Great start — you're a third of the way",
  4: 'Past halfway! Keep going',
  5: 'Almost there — last few details',
  6: 'You made it!',
};
